var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v("MOBILE TERMS OF USE")])])]), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" These Mobile Text Terms of Use (“Mobile TOU”) govern your use of the text messaging information and marketing program (the “Program”) provided by Motto Mortgage (the “Company”). Please read this Mobile TOU carefully. By opting into the Program, you agree to this Mobile TOU, the Company’s online  ")]), _vm._v(" PRIVACY POLICY and t "), _c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v("he Company’s overall")]), _vm._v(" TERMS OF USE, "), _c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v("  as amended from time to time (collectively, the “Terms”). Your access to, and use of, the Program represents your agreement to these Mobile TOU. ")]), _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" ")])]), _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" IF YOU DO NOT AGREE WITH THESE TERMS, INCLUDING CHANGES THERETO, DO NOT ACCESS, SUBSCRIBE OR USE THE PROGRAM. ")])])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" The Company’s Program is an informational and marketing program that sends its users updates on events, as well as great deals and special offers. This information is delivered directly to their mobile phones, via SMS and/or MMS. As a Program member, you may receive event invitations, insider news, access to special events, deals, and other Motto marketing and informational communications.  ")])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v("General Mobile Messaging Terms")])])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" When you provide the Company with your mobile phone number, you are expressly agreeing that the Company may  ")]), _c('span', {
    staticStyle: {
      "font-family": "Roboto, serif"
    }
  }, [_vm._v("send ")]), _c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v(" Motto Mortgage Network Alert text messages (including SMS and MMS) to that phone number which will provide important messages from the Company regarding marketing, events, and general information about tools, services and support for the Motto Mortgage network. ")]), _c('span', {
    staticStyle: {
      "font-family": "Roboto, serif"
    }
  }, [_vm._v(" ")]), _c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" You also agree to pay the charges to your wireless bill or to have them deducted from your prepaid balance for this service. You acknowledge that you are thirteen years of age or older and you have the consent of the wireless account holder. The Company may send recurring automated marketing mobile messages per month. The number of text messages you receive will depend on your activity with Motto. When you sign up, you will receive a confirmation text message, and you may need to reply as instructed to complete registration. Message and data rates apply. Reply STOP to cancel, HELP for help.  ")])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" Texts may be sent automatically, including via an automatic telephone dialing system and/or sequencing system. Consent is not required as a condition of purchasing any goods or services. You agree to notify the Company of any changes to your mobile number and update your subscription with the Company to reflect this change. Your carrier may prohibit or restrict certain mobile features and certain mobile features may be incompatible with your carrier or mobile device. Contact your carrier with questions regarding these issues.   ")])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v("Stop Receiving Promotional Text Messages")])])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" To stop receiving promotional text messages from the Company, simply reply STOP to any text sent by the Company.  If you opt-out, you agree to receive a final text message confirming your opt-out. ")])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" Note: “STOP” requests are not case sensitive.  ")])]), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "font-size": "12pt",
      "color": "#212121"
    }
  }, [_vm._v(" Alternatively, you can opt-out of receiving texts from the Company by either sending an email with your mobile phone number to  ")]), _c('span', {
    staticStyle: {
      "font-size": "12pt",
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("help@mottomortgage.com")]), _c('span', {
    staticStyle: {
      "margin-bottom": "8pt",
      "font-family": "Roboto, serif",
      "font-size": "12pt",
      "color": "#212121"
    }
  }, [_vm._v(" , or by calling 1-866-MOTTO60. Please allow up to 10 business days from when the request was received to process your removal.  ")])]), _c('p', {
    staticStyle: {
      "margin-top": "8pt",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v("Questions /")]), _c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Comments / Concerns")])])]), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "font-size": "12pt",
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v(" Please direct all comments, questions or concerns regarding the Company’s text messaging program to  ")]), _c('span', {
    staticStyle: {
      "font-size": "12pt",
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("help@mottomortgage.com")]), _c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "font-size": "12pt",
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("  or our support line at 1-866-MOTTO60. ")])]), _c('p', {
    staticStyle: {
      "margin-top": "8pt",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Help Command")])])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v("For help at any time, text HELP to ")]), _c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "background-color": "#fff"
    }
  }, [_vm._v("58476")]), _c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" or reply HELP to any text from ")]), _c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "background-color": "#fff"
    }
  }, [_vm._v("58476")]), _c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" . This text messaging marketing program is free from the Company, but message & data rates may apply.  ")])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v("Requirements")])])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v("To take advantage of the Company’s t")]), _c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v(" ext messaging marketing program, you must have a text messaging-enabled mobile device with a text messaging plan. To receive the Company’s text messages you must Opt-in via the web form in MottoCenter or by texting MOTTOVATED to 58476.  Message frequency varies.  Message and data rates may apply ")]), _c('span', {
    staticStyle: {
      "font-family": "'Roboto', serif",
      "font-size": "12pt",
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v(".  ")])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v("Carriers Supported")])])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" The Company’s text messaging marketing program works with all major U.S. carriers including currently: AT&T, Sprint, T-Mobile®, Verizon Wireless, Boost, Cricket, MetroPCS, U.S. Cellular, Virgin Mobile, and a host of other smaller regional carriers.  ")])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "8pt",
      "font-size": "12pt"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v("Change of Terms")])])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0",
      "font-size": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" The Company reserves the right to modify these Mobile TOU by posting new versions on the Company’s website. Your ")]), _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" ")])]), _c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121"
    }
  }, [_vm._v(" continued use of the Program following such changes constitutes your acceptance of those changes. ")])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0",
      "font-size": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif"
    }
  }, [_vm._v(" ")])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0",
      "font-size": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif"
    }
  }, [_vm._v(" ")])]), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0",
      "font-size": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121",
      "background-color": "#fff"
    }
  }, [_vm._v(" These Mobile Text Terms of Use (“Mobile TOU”) govern your use of the text messaging information and marketing program (the “Program”) provided by Motto Mortgage (the “Company”). Please read this Mobile TOU carefully. By opting into the Program, you agree to this Mobile TOU, the Company’s online PRIVACY POLICY and the Company’s overall TERMS OF USE, as amended from time to time (collectively, the “Terms”). Your access to, and use of, the Program represents your agreement to these Mobile TOU. ")]), _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121",
      "background-color": "#fff"
    }
  }, [_vm._v(" ")])]), _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Roboto, serif",
      "color": "#212121",
      "background-color": "#fff"
    }
  }, [_vm._v(" IF YOU DO NOT AGREE WITH THESE TERMS, INCLUDING CHANGES THERETO, DO NOT ACCESS, SUBSCRIBE OR USE THE PROGRAM ")])])])]);
}]

export { render, staticRenderFns }